// @ts-nocheck
/* eslint-disable */
/* This file was generated by Unframer for Framer project 87f9c755347dad76 "VastiPost", do not edit manually */
// virtual:__routes
var routes = {
  "AwqnHW0QF": {
    "path": "/content"
  },
  "D4Jx22RYL": {
    "path": "/postcomments"
  },
  "E1_38kSca": {
    "path": "/analytics"
  },
  "GLxxVmw2x": {
    "path": "/budgetsettings"
  },
  "Hk7_4sISS": {
    "path": "/selectcampaign"
  },
  "IiZO2Cv6D": {
    "path": "/engagement"
  },
  "KF7I9uclg": {
    "path": "/analyticsettings"
  },
  "NPReGYhXB": {
    "path": "/notifications"
  },
  "Nxb1iHG5m": {
    "path": "/campaigndraft"
  },
  "O0cIGXnzw": {
    "path": "/automessagesettings"
  },
  "PALX1Qsm2": {
    "path": "/paidcampaign"
  },
  "UgU1ikFqx": {
    "path": "/postlikes"
  },
  "YqXaz8HBZ": {
    "path": "/eventdetails"
  },
  "Z_FCyMXmC": {
    "path": "/milestones"
  },
  "a2bOeZw72": {
    "path": "/mediaupload"
  },
  "augiA20Il": {
    "path": "/"
  },
  "axnq2tZ_L": {
    "path": "/mentions"
  },
  "aygRaQUEq": {
    "path": "/securitysettings"
  },
  "bRmTQqsFx": {
    "path": "/system-ux"
  },
  "c1vFKrceL": {
    "path": "/autocommentpostsettings"
  },
  "cGGTjO6OZ": {
    "path": "/calendar"
  },
  "cmXGPgUN6": {
    "path": "/selectpost"
  },
  "f5ZeuDCP6": {
    "path": "/profilesettings"
  },
  "fHBCln_yE": {
    "path": "/conceptdetails"
  },
  "gGyQXKjwO": {
    "path": "/integrationsettings"
  },
  "gmDANFuXu": {
    "path": "/automationsettings"
  },
  "iOSmnupJa": {
    "path": "/postdetails"
  },
  "j1BRPygnj": {
    "path": "/audiences"
  },
  "lwEOpANmj": {
    "path": "/suggestedpost"
  },
  "md70lCcqt": {
    "path": "/contentsettings"
  },
  "oK0BEj3rE": {
    "path": "/connectedprofiles"
  },
  "qgZGtjv8g": {
    "path": "/messages"
  },
  "ufQGzrHoc": {
    "path": "/messagereply"
  },
  "xDl_07vkp": {
    "path": "/postdraft"
  },
  "xdDqIhOI4": {
    "path": "/commentreply"
  },
  "yDM12PhTS": {
    "path": "/organiccampaign"
  },
  "yLOf6fquB": {
    "path": "/webbrowser"
  },
  "zl_aWu8Xa": {
    "path": "/campaigns"
  }
};

export {
  routes
};
